<script setup>
import api from "@shop/frontend/web/js/api";
import { translator } from "@shop/frontend/web/js/services/TranslatorService";
import { ref } from "vue";
import useCartStore from "../../store/modules/cart";

const cartStore = useCartStore();
const props = defineProps({
	orderId: {
		type: Number,
		required: true,
	},
	initialCode: {
		type: String,
		default: "",
	},
});
const emit = defineEmits(["applied"]);

const placeholder = translator.t("main", "Enter promotional code");

const code = ref(props.initialCode);
const message = ref("");
const applied = ref(props.initialCode !== "");

function apply() {
	api.promo
		.apply({ orderId: props.orderId, code: code.value })
		.then(res => {
			if (!res.status) throw new Error(res.msg);
			if (!res.carts) throw new Error("Не удалось получить билеты");

			applied.value = true;
			cartStore.updateOrderSale(props.orderId, res.discount);

			return emit("applied", {
				...res,
				code: code.value,
				order_id: props.orderId,
			});
		})
		.catch(error => {
			message.value = error.message ?? translator.t("main", "An error occurred!");
		});
}
</script>

<template>
	<div class="i-promo" :class="{ active: code !== '' }">
		<div class="i-promo__wrapper">
			<input
				v-model="code"
				class="i-promo__input"
				type="text"
				aria-label="promocode"
				:placeholder="placeholder"
				:disabled="applied"
				@keyup.enter="apply"
				@input="message = ''"
			/>

			<button
				class="i-promo__button"
				type="button"
				:class="{ active: applied }"
				:disabled="applied"
				@click="apply"
			>
				{{ applied ? "Применён" : "Применить" }}
			</button>
		</div>
		<div class="i-promo__message" :class="{ error: message !== '' }">{{ message }}</div>
	</div>
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-promo.scss";
</style>
